import React from "react";
import { TableHeaderColumn } from "react-bootstrap-table";
import Crud from "../Crud";

function PaymentMethod() {
  return (
    <Crud
      title="Payment Method"
      getUrl={() => "/Player/PaymentMethod_GetList"}
      // INSERT
      insertUrl={() => "/Player/PaymentMethod_Insert"}
      insertParams={({ userId }, { paymentMethodName }) => ({
        PaymentMethodName: paymentMethodName,
        IdUser: Number(userId),
      })}
      // UPDATE
      updateUrl={() => "/Player/PaymentMethod_Update"}
      updateParams={({ userId }, { idPaymentMethod, paymentMethodName }) => ({
        IdPaymentMethod: idPaymentMethod,
        PaymentMethodName: paymentMethodName,
        IdUser: Number(userId),
      })}
      // DELETE
      deleteUrl={() => "/Player/PaymentMethod_Delete"}
      deleteParams={({ userId }, id) => ({
        IdPaymentMethod: id,
        IdUser: Number(userId),
      })}
    >
      <TableHeaderColumn
        visible="none"
        hiddenOnInsert
        autoValue={true}
        hidden
        isKey
        dataField="idPaymentMethod"
      >
        Id
      </TableHeaderColumn>
      <TableHeaderColumn
        dataField="paymentMethodName"
        filter={{ type: "TextFilter", delay: 1000 }}
      >
        Name
      </TableHeaderColumn>
    </Crud>
  );
}

export default PaymentMethod;
